'use client';

import { usePathname } from 'next/navigation';
import type { ElementType } from 'react';

import { trackContentfulClick } from '../../gtm';
import type { ContentfulClickProps } from './types';

export function ContentfulClick<T extends ElementType = 'div'>({
    component,
    eventData,
    onClick,
    ...props
}: ContentfulClickProps<T>) {
    const Component = component ?? 'div';
    const pathname = usePathname();

    return (
        <Component
            {...props}
            onClick={e => {
                onClick?.(e);
                trackContentfulClick({
                    ...eventData,
                    promoOrigin: pathname,
                });
            }}
        />
    );
}
